import { secureRequest } from "utils/request";

const reqPath = ["/video/online"];

export const getFilters = () => {
    return secureRequest("/api/v1/map/filters", reqPath);
};

export const getMapVehicles = (vehicles: Array<number>) => {
    return secureRequest(`/api/v1/map/online?q=${vehicles.join(',')}`, reqPath)
};

export const getMapVehicle = (id: number) => {
    return secureRequest(`/api/v1/map/online/${id}`, reqPath)
};